import type { BillingProgressViewModel } from "../types";

import {
  getEligibleModuleCount,
  getNextTierBundleDiscountPct,
} from "./pricing";
import type { BillingModule } from "./types";

type ProjectProgressInput = Readonly<{
  bundleSavingsPct: number;
  isUnlimited: boolean;
  modules: BillingModule[];
  unlimitedSavingsPct?: number;
}>;

export const projectProgress = ({
  bundleSavingsPct,
  isUnlimited,
  modules,
  unlimitedSavingsPct,
}: ProjectProgressInput): BillingProgressViewModel => {
  if (isUnlimited) {
    return {
      current: 4,
      filledSegments: 3,
      label: "You're getting the best deal",
      ...(unlimitedSavingsPct && unlimitedSavingsPct > 0
        ? { savingsPct: unlimitedSavingsPct }
        : {}),
      state: "complete",
      segmentCount: 3,
      total: 4,
    };
  }

  const current = getEligibleModuleCount(modules);
  // The first eligible module earns 0%; the bundle discount only starts at two
  // modules, so from a zero-module start it takes two adds to reach nextSavingsPct.
  const nextSavingsPct = getNextTierBundleDiscountPct(Math.max(1, current));
  const label =
    current > 4
      ? ""
      : current === 4
        ? "Add 1 more to unlock Unlimited"
        : current === 0
          ? `Add 2 modules to save ${nextSavingsPct}%`
          : current === 1
            ? `Add 1 module to save ${nextSavingsPct}%`
            : `Add 1 more to save ${nextSavingsPct}%`;

  return {
    current,
    filledSegments: Math.min(2, Math.max(0, current - 1)),
    label,
    ...(current < 4 ? { next: current + 1 } : {}),
    ...(bundleSavingsPct > 0 ? { savingsPct: bundleSavingsPct } : {}),
    state: current <= 1 ? "empty" : "progressing",
    segmentCount: 3,
    total: 4,
  };
};
